import React, { useEffect } from "react";
import styled from "styled-components";
import { Images } from "../../../../assets/images";
import { ButtonContainer } from "./Offerings";
import { PrimaryCTAButton } from "../../../common/CustomButtons";
import { navigate } from "@reach/router";
import OptimizedBgImage from "./OptimizedBgImage";

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <MainWrapper>
      <ContentContainer>
        <ImageSection>
          <OptimizedBgImage
            src={Images.AboutJustact}
            alt="About IAMC"
            height="100%"
            borderRadius="clamp(12px, 2vw, 20px)"
          />
        </ImageSection>

        <ContentCard>
          <HeaderSection>
            <MainTitle>ready, relaxed, resolution</MainTitle>
          </HeaderSection>

          <ContentSection>
            <Description>
              IAMC was founded in 2019 with a mission to provide easy access
              to justice and ease the burden on courts by providing a platform
              for people, enterprises and institutions to resolve disputes. The
              platform is built on the Principles of Natural Justice and to
              promote amicable settlements.
            </Description>

            <LeadershipList>
              <LeadershipItem>Institution is guided by</LeadershipItem>
              <LeadershipItem>
                Our Chairman - Retd. Judge of Punjab & Haryana High Court
              </LeadershipItem>
              <LeadershipItem>
                Senior Advocate – Madras High Court
              </LeadershipItem>
              <LeadershipItem>
                Former Managing Director of Deutsche Bank
              </LeadershipItem>
              <LeadershipItem>
                Ex-Registrar General & Census Commissioner of India (Retd. IAS
                Officer)
              </LeadershipItem>
            </LeadershipList>

            {/* <ClosingText>
              Institution is guided by Our Chairman - Retd. Judge of Punjab &
              Haryana High Court Senior Advocate – Madras High Court Former
              Managing Director of Deutsche Bank Ex-Registrar General & Census
              Commissioner of India (Retd. IAS Officer)
            </ClosingText> */}
          </ContentSection>

          <ButtonContainer>
            <PrimaryCTAButton
              style={{ width: "100%", maxWidth: "250px" }}
              onClick={() => navigate("/about-us")}
            >
              Know More
            </PrimaryCTAButton>
          </ButtonContainer>
        </ContentCard>
      </ContentContainer>
    </MainWrapper>
  );
};

export default About;

const MainWrapper = styled.section`
  width: 100%;
  padding: clamp(2rem, 5vw, 4rem) clamp(1rem, 3vw, 2rem);
  box-sizing: border-box;
  background: #f8fafc;

  @media (min-width: 1600px) {
    padding: 6rem 4rem;
  }
`;

const ContentContainer = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: clamp(2rem, 4vw, 4rem);
  align-items: center;
  min-height: clamp(500px, 60vh, 650px);

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 2rem;
    min-height: auto;
  }
`;

const ImageSection = styled.div`
  width: 100%;
  height: 100%;
  min-height: clamp(300px, 40vh, 500px);
  border-radius: clamp(12px, 2vw, 20px);
  overflow: hidden;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);

  @media (max-width: 1024px) {
    order: 2;
  }
`;

export const Image = styled.div`
  width: 100%;
  height: ${({ height }) => (height ? height : "100%")};
  background: url(${(props) => props.bgImage}) center/cover no-repeat;
  background-color: #f0f0f0;
`;

const ContentCard = styled.div`
  background: white;
  border-radius: clamp(16px, 2vw, 24px);
  padding: clamp(1.5rem, 4vw, 3rem);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  gap: clamp(1rem, 2vw, 1.5rem);
  position: relative;
  z-index: 2;

  @media (min-width: 1025px) {
    margin-left: clamp(-1rem, -3vw, -2rem);
  }

  @media (max-width: 1024px) {
    margin-left: 0;
    order: 1;
  }
`;

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const SectionLabel = styled.p`
  color: #00818a;
  font-family: "Open Sans", sans-serif;
  font-size: clamp(0.875rem, 1.5vw, 1rem);
  font-weight: 600;
  margin: 0;
  letter-spacing: 0.5px;
  text-align: ${({ textAlign }) => (textAlign ? textAlign : "left")};
`;

const MainTitle = styled.h2`
  font-family: openSans-SemiBold, sans-serif;
  color: #293461;
  font-weight: 600;
  font-size: clamp(1.5rem, 3vw, 2rem);
  line-height: 1.3;
  margin: 0;
`;

const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: clamp(0.75rem, 2vw, 1.25rem);
`;

const Description = styled.p`
  color: #293461;
  font-family: openSans-Regular, sans-serif;
  font-size: clamp(0.95rem, 2vw, 1.125rem);
  line-height: 1.6;
  margin: 0;
`;

const LeadershipList = styled.div`
  display: flex;
  flex-direction: column;
  gap: clamp(0.5rem, 1vw, 0.75rem);
`;

const LeadershipItem = styled.p`
  color: #293461;
  font-family: openSans-Regular, sans-serif;
  font-size: clamp(0.95rem, 2vw, 1.125rem);
  line-height: 1.6;
  margin: 0;
  position: relative;
  padding-left: 1rem;

  &::before {
    content: "•";
    color: #00818a;
    font-weight: bold;
    position: absolute;
    left: 0;
  }
`;
